import Materiais from "../routes/materiais";
import Boletos from "../routes/boletos";
import RelatorioPagamentos from "../routes/relatorioPagamentos/RelatorioPagamentos";
import PedidosEscola from "../routes/pedidosEscola";
import Catalogo from "../routes/catalogo";
import Carrinho from "../routes/carrinho";

export default [
  {
    path: "materiais",
    component: Materiais,
    title: "Materiais",
  },
  {
    path: "boletos",
    component: Boletos,
    title: "Faturas - Painel de controle",
  },
  {
    path: "relatorio-pagamentos",
    component: RelatorioPagamentos,
    title: "Fatura da escola",
  },
  {
    path: "pedidos-escola",
    component: PedidosEscola,
    title: "Pedidos da Escola",
  },
  {
    path: "catalogo",
    component: Catalogo,
    title: "Catálogo",
  },
  {
    path: "carrinho",
    component: Carrinho,
    title: "Meu carrinho",
  },
];
